/*
 view_methods.js
 create and handle selection list to be inserted in a <form>

 <form action="/foo">

 <select name="cars">
 <option value="volvo">Volvo</option>
 <option value="saab">Saab</option>
 <option value="fiat">Fiat</option>
 <option value="audi">Audi</option>
 </select>

 </form>

 The options are  build from the structure below:
 {
 methodname1: {
 executeUrl: "/pp?flow=EnvoyInitDepositJson"
 formTemplateCode: "NO-FIELDS"
 formTemplateUrlParams: "&paymentMethodId=42&paymentType=deposit"
 logoImgClasses: ["visa","mastercard","other"]
 methodId: 42
 methodInfo: "??BPAY_INFO_DEPOSIT??"
 methodName: "BPay"
 methodText: "bPay"
 paymentType: "deposit"
 sendHandlerType: "EXTERNAL_WINDOW"
 },
 methodname2: {..same structure as above..
 }
 methodnameN: {..same structure as above..
 }
 }
 */
import actions from '../../common/lib/utils/actions.js';
import core from '../../common/lib/core.js';
// import viewTextkeys from '../../commonview/lib/view-textkeys.js';

const create = core.create; // creates basic elements not inserted into the dom
const nodetree = core.nodetree; // inserts an array of elements into a document-fragment which later may be inserted into the dom
const classnameShow = 'u-show';
const classnameHide = 'u-hide';
// let textkeysObj = {};

function createSelectMethod(eventFilter) {
	const cName = `${eventFilter} payment__select-methods`;
	return create({
		type: 'select',
		class: cName
	});
}

function createOptions(objByName, selectedMethodId) {
	/* see input format above */
	const nodes = [];
	Object.keys(objByName).forEach((name) => {
		/* A reference to the element is saved. */
		const elm = create({
			type: 'option',
			class: 'payment__option-method',
			value: (objByName[name].methodId || 'method-id-missing')
		});
		elm.innerHTML = (objByName[name].methodText || 'methodtext missing'); // TODO: textkey?
		if (objByName[name].methodId === selectedMethodId) {
			elm.selected = true;
		}
		/* The uninserted nodes are returned as a list to be inserted with 'nodetree'-function. */
		nodes.push(elm);
	});
	return nodes;
}

function valueToOptionIndex(num, arr) {
	let arrIndex = null;
	const numToStr = num.toString();
	arr.forEach((elm, index) => {
		if (elm.getAttribute && elm.getAttribute('value') && elm.getAttribute('value') === numToStr) {
			arrIndex = index;
		}
	});
	return arrIndex;
}

function mainHandler(e, onEventCb, eventFilterSeparatorClassname) {
	const eventFilterSelector = `.${eventFilterSeparatorClassname}`;

	function cb(p) {
		p.e.stopPropagation();
		/* get method from the selectbox */
		const selectElm = p.elm;
		const selectedOptionIndex = selectElm.selectedIndex;
		const optionElm = selectElm[selectedOptionIndex];
		const methodId = optionElm.value;
		const methodName = optionElm.text;
		onEventCb();
		actions.viewMethods(methodId, methodName);
	}
	/* If the last argument is set to 'true', the handler function runs the callback if the .fkn_filter element or any of its children (#content_A,#content_B,#inner_content) is clicked */
	core.handle(e, eventFilterSelector, cb, true);
}

function addListeners(elm, cbOnEvent, eventFilter, eventType) {
	function handleCreator(e) {
		mainHandler(e, cbOnEvent, eventFilter);
	}
	core.addListener(elm, eventType, handleCreator);
	return handleCreator;
}

function removeListeners(elm, handler, eventType) {
	if (elm) {
		core.removeListener(elm, eventType, handler);
	}
}

function show(elm) {
	if (elm) {
		core.removeClass(elm, classnameHide);
		core.addClass(elm, classnameShow);
	}
}

function hide(elm) {
	core.removeClass(elm, classnameShow);
	core.addClass(elm, classnameHide);
}

export default {
	create() {
		let elements = {};
		const mainEventType = 'change';
		const classNameEventFilter = 'js-eventfilter-viewmethods';
		// textkeysObj = viewTextkeys.depositflow();
		elements.wrap = (elements.wrap || createSelectMethod(classNameEventFilter));
		const callbackOnMainEvent = function temp() {};
		const handler = addListeners(elements.wrap, callbackOnMainEvent, classNameEventFilter, mainEventType);
		return {
			wrap: elements.wrap,
			show() {
				show(elements.wrap);
			},
			hide() {
				hide(elements.wrap);
			},
			update(state) {
				const payM = (state && state.paymentmethods);
				const selectedMethodId = ((payM && payM.selected) && payM.selected.id);
				const byNameList = ((payM && payM.methods) && payM.methods.by_name);
				let optIndex = null;
				if (byNameList) {
					if (elements.options && selectedMethodId) {
						/* update selected option if the list list is refreshed programatically */
						optIndex = valueToOptionIndex(selectedMethodId, elements.options);
						if (elements.options[optIndex]) {
							elements.options[optIndex].selected = true;
						}
					} else {
						elements.options = createOptions(byNameList, selectedMethodId);
						elements.wrap.appendChild(nodetree(elements.options));
					}
				}
			},
			close() {
				/* hide the spinner if the spinner is closed before hidden.
				Otherwise the '.dim' element will remain on the parent */
				removeListeners(elements.wrap, handler, mainEventType);
				elements = core.deleteElementsInObjectExcept(elements, [], 'view_methods:248');
				return null;
			}
		};
	}
};



// WEBPACK FOOTER //
// ./mobile-core/src/payment/payment/lib/view-methods.js